import React from "react";
import './ImageDisplay.css';

const ImageDisplay =({url,box})=>{
    if(url){

          return(

    <div className="center ma">
        <div className="absolute mt2">
            <img id='faceimg' src={url} alt='image' width='500px' height='auto'/>
            <div className="boundingbox" style={{top:box.topRow, left: box.leftCol , right:box.rightCol, bottom:box.bottomRow }}></div>
        </div>    
    </div>

    );
    }
}
// const myTimeout = setTimeout(ImageDisplay, 2000);
export default ImageDisplay;